/** @import modules */

import { useTranslation }           from "react-i18next";

import { useParams, useNavigate }   from "react-router-dom";

/** @import hooks */

import { TyresNavigator }           from "../../../../../Hooks/TyresNavigator";

/** @import components */

import SearchableSelect             from "../../../../Shared/SearchableSelect";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns VehicleType filter component
 * 
 */

const VehicleType = ( { attributes } ) => { const 

    { t }               = useTranslation    (),

    navigate            = useNavigate       (),

    { parameters }      = useParams         (),

    Filter = ( value ) => { const 

        object = { f : 12, l: null, a: null, b: null, vt: ( value === "default" ) ? null : value, loc: window.pageYOffset };

        return navigate (  
            
            `/shop/tyres/${
            
                new URLSearchParams ( TyresNavigator ( parameters, object ) ).toString () }` );

    };

    /** @return component */

    return ( <div className="content vehicle-type">

        <div className="select shadow-select">

            <SearchableSelect
                options={ attributes.map ( opt => ( { text: opt.value, value: opt.value } ) ) }
                value={ new URLSearchParams ( parameters ).get ( "vt" ) || "default" }
                onChange={ Filter }
                formatOption={ opt => t ( opt.value ) }
                label={ t ( "select_option" ) }
            />

        </div>

    </div> );

}

/** @export VehicleType */
 
export default VehicleType;